import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { getProductData } from '@elem/utils/getProductData';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { productDetailData, productFaqBySpuId } from '@/service';
import { useSupportData } from '@/utils/hooks';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}

export default function GetProductData() {
    const { gloproductlist } = useGlobal();
    const { productPageData } = useProductStore();
    const dispatch = useProductDispatch();
    const { locale } = getLocal();
    const generalKeys: GeneralKeyItemProps[] = [
        // river 3
        // { key: 'product_ps_river_river_705', url: locale === 'jp' ? 'river-3-portable-power-station' : 'river-3-series-portable-power-station' },
        // river 3 plus
        { key: 'product_ps_river_703', url: 'river-3-plus-portable-power-station' },
    ];

    useEffect(() => {
        const getProductSeriesData = async () => {
            const promiseAll = new Set();
            let proMsgAll: any[] = [];
            const productPageData = {
                productCatagory: null,
                productSeries: [],
                supportDataArr: [],
            };
            let len = 0;
            generalKeys?.map((item: GeneralKeyItemProps, _: number) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                if (Object.keys(productMsg)?.length > 0) {
                    proMsgAll.push(productMsg);
                    promiseAll.add(productDetailData({ handle: item.url }, locale || 'us'));
                    len++;
                    promiseAll.add(getProductMsg(locale, productMsg));
                    len++;
                }
            });
            // promiseAll.add(productFaqBySpuId({ spuId: productMsg?.sourceId }, locale));

            try {
                const res: any = await Promise.all(promiseAll);
                if (proMsgAll?.length > 0 && len > 0 && res) {
                    for (let i = 0; i < len; i++) {
                        const flag1 = res[i] && res[i]?.code === '0';
                        const flag2 = res[i];
                        if (i % 2 === 0) {
                            if (flag1) {
                                if (i === 0) {
                                    productPageData.productCatagory = res[i]?.data?.productCatagoryResponseList;
                                }
                                productPageData.productSeries.push(res[i]?.data?.spuResponse);
                            }
                        } else {
                            if (flag2) {
                                productPageData.supportDataArr.push({
                                    supportData: res[i]?.supportData,
                                    prodectDetail: proMsgAll[(i - 1) / 2],
                                });
                            }
                        }
                    }
                    dispatch({
                        type: 'changeProductPageData',
                        payload: productPageData,
                    });
                }
            } catch (e: any) {
                console.error('error', e);
            }
        };

        const productCatagory = productPageData?.productCatagory;
        if (!productCatagory) {
            getProductSeriesData();
        }
    }, []);

    return null;
}
